import MainContainer from "../../components/container/MainContainer";

const IncomeVarianceReport = () => {
  return <MainContainer>IncomeVarianceReport</MainContainer>;
};

export default IncomeVarianceReport;
